export default "__VITE_ASSET__DXKSFwpA__"